module.exports = __webpack_public_path__ + "img/symbol_8.57eb8846.png";